import { Hint } from '@3plearning/question-components-library';
import {
    Box,
    Text
} from '@chakra-ui/react';
import React, { FC } from 'react';

import { HintContent } from '../../components/hint/hint-content';
import { lokalisation } from '../../helpers/lokalisation';
import { NavButtons } from './nav-buttons';
import { HeaderCtnr } from './preview.styled';
import { QuestionHeaderProps } from './preview.types';

export const QuestionHeader: FC<QuestionHeaderProps> = ({
    navigate,
    totalQuestions,
    questionNumber,
    hintContent
}) => {
    const { previewTxt } = lokalisation();

    return (
        <HeaderCtnr>
            <Box
                mr={'20px'}
                display={!hintContent ? 'none' : 'block'}
            >
                <Hint>
                    <HintContent
                        content={hintContent}
                    />
                </Hint>
            </Box>
            <Box className={'question'}>
                {previewTxt.question} <Text as={'span'} className={'question-num'}>{questionNumber + 1}</Text>/{totalQuestions}
            </Box>
            <NavButtons navigate={navigate} />
        </HeaderCtnr>
    );
};
